import {User} from 'app_api/me/types';

import {BaseClient} from '../utils/base-client';

class UserDetailsClient extends BaseClient<User> {
  buildEndpoint() {
    return `api/app/me/`;
  }

  buildQueryParams({projectId, includeWorkspaceUsers = false}) {
    return {
      // eslint-disable-next-line
      include_workspace_users: includeWorkspaceUsers,
      // eslint-disable-next-line
      project_id: projectId,
    };
  }

  processResponse(response) {
    return response.results;
  }
}

export const userDetailsClient = new UserDetailsClient();
